import * as THREE from "three";
import { Building } from "./Building";
import { Lights } from "./Lights";
import { Road } from "./Road";
import { Terrain } from "./Terrain";
import { Overhead } from "./Overhead";

export interface TrackProps {
  curve: THREE.CurvePath<THREE.Vector3>;
}

export function Track({ curve }: TrackProps) {
  return (
    <group>
      <Terrain />
      <Road curve={curve} />
      <Building position={[4, 4, 32]} />
      <Building position={[4, 4, -4]} />
      <Building position={[28, 4, -4]} rotateY={Math.PI} />
      <Building position={[28, 4, 32]} rotateY={Math.PI} />
      <Overhead position={[8, 0, -16]} url="./images/screen4.png" />
      <Overhead position={[16, 0.5, -36]} url="./images/screen2.png" />
      <Overhead position={[0, 2.5, -24]} url="./images/screenFront.png" />
      <Lights />
    </group>
  );
}
